import React, { useState } from "react";
import { Col, Form, Row, Table, Image, Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import Media from "react-media";
import moment from "moment";
import TimeInput from "material-ui-time-picker";
import { ToggleButtonReuseTwo } from "../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/AllButton/ToggleButtonReuse";
import { AddButtonIconComponent } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { BasicDateRangePicker } from "./DatePickerRange";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";

export const ManageHoursOperation = () => {
  //state
  const [showEditRole, setShowEditRole] = useState(!false);
  const handleShowEditRole = () => setShowEditRole(true);
  const handleCloseEditRole = () => setShowEditRole(false);
  const [modelStep, setModelStep] = useState(false);
  const [state, setState] = useState({
    time: "",
  });
  const changeStep = (e) => {
    e.preventDefault();
    setModelStep(!modelStep);
    // setShowEditRole(false);
  };
  const handleChange = (time) => {
    setState(time);
  };
  return (
    <React.Fragment>
      {/* <Media query="(max-width: 991px)">
        <div>Mobile</div>
      </Media>
      <Media query="(min-width: 992px)">
        <div>Desktop</div>
      </Media> */}
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={2} />
          </div>
          <div className="super-admin-right-side-panel">
            <div className="super-admin-inside-right-side-panel">
              <RightSideNavigation />
              <div className="pt-4 pb-4 mobile-mt-4">
                <div className="f18-700 my-2">
                  Manage Hours of Operation for a Date
                </div>
                <div className="f14-400">
                  Manage/Block your reservation calendar according to your daily
                  schedule
                </div>
              </div>
              <Row className="align-items-center">
                <Col lg={6} xs={5}>
                  <NewInputText inputType="date" extraClass="mb-0 w220" />
                </Col>
                <Col lg={6} xs={7} align="right">
                  <div>
                    <button
                      type="button"
                      className="f16-500 text-gray enLightGrayBtn bg-transparent py-1"
                      onClick={handleShowEditRole}
                      style={{fontSize:"0.56rem"}}
                    >
                      <Image
                        src={require("../../../assets/images/UserManagement/copy.svg")}
                        alt="calendar"
                        title="calendar"
                        width="20px"
                      />
                      Copy Timing to <br /> another day
                    </button>
                  </div>
                </Col>
              </Row>
              <hr />
              <Media query="(min-width: 991px)">
              <div className="user-table-reusable-superadmin table-responsive">
                <Table>
                  <thead>
                    <tr className="super_admin_all_users_table_head">
                      <th style={{ width: "25%" }} className="f12-700">
                        Meals
                      </th>
                      <th style={{ width: "25%" }} className="f12-700">
                        Start Time
                      </th>
                      <th style={{ width: "25%" }} className="f12-700">
                        End Time
                      </th>
                      <th style={{ width: "25%" }} className="f12-700">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <div className="mt-2 mb-2 today-date-dropdown-seating-dashboard">
                    <div>
                      <h4>Today, {moment().format("Do MMM YYYY")}</h4>
                    </div>
                    <div className="seating-dashboard-today-line">
                      <hr className="line" />
                    </div>
                  </div>
                  <tbody>
                    <tr className="super_admin_all_users_table_body">
                      <td colSpan="7" className="p-0 w-100">
                        <table className="w-100 HideShowTable enMinWidth900">
                          <tbody>
                            <tr className="border-bottom">
                              <td style={{ width: "28%" }}>
                                <NewInputText extraClass="w220 mb-0" />
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "25%" }}>
                                <ToggleButtonReuseTwo />
                              </td>
                            </tr>
                            <tr className="border-bottom">
                              <td style={{ width: "28%" }}>
                                <NewInputText extraClass="w220 mb-0" />
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "25%" }}>
                                <ToggleButtonReuseTwo />
                              </td>
                            </tr>
                            <tr className="border-bottom">
                              <td style={{ width: "100%" }} colSpan="4">
                                <div className="d-flex justify-content-between">
                                  <AddButtonIconComponent
                                    buttonText="Add Another Slot"
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                  <div className="enIconBtn">
                                    <Image
                                      src={require("../../../assets/images/UserManagement/Delete.svg")}
                                      alt="Delete"
                                      title="Delete"
                                      fluid
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              </Media>

            <Media query="(max-width: 991px)">
              <>
                <div className="row seating-dashboard-table">
                  <div className="col-3 p-0">
                    <p className="f12-700 pl-3">
                      Meals
                    </p>
                  </div>
                  <div className="col-3 mpl-1 mpr-1">
                    <p className="f12-700">
                      Start Time
                      </p>
                  </div>
                  <div className="col-3 mpl-1 pr-0">
                    <p className="f12-700">
                    End Time
                    </p>
                  </div>
                  <div className="col-3 mpl-1 pl-3">
                    <p className="f12-700">
                      Action
                      </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 p-0">
                    {/* <Accordion>{renderScanAccordian()}</Accordion> */}
                    <tr className="border-bottom d-flex">
                              <td style={{ width: "28%"}} className="px-2">
                                <NewInputText extraClass="mb-0" />
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "25%" }} className="pl-4">
                                <ToggleButtonReuseTwo />
                              </td>
                            </tr>
                            <tr className="border-bottom d-flex pt-2">
                              <td style={{ width: "28%" }} className="px-2">
                                <NewInputText extraClass="mb-0" />
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td
                                style={{ width: "25%" }}
                                className="standard-hours-main"
                              >
                                <div className="standard-hours-main-sectiontwo">
                                  <div className="standard-hours-main-sectiontwo-insidetoggle">
                                    <TimeInput mode="12h" />
                                  </div>
                                </div>
                              </td>
                              <td style={{ width: "25%" }} className="pl-4">
                                <ToggleButtonReuseTwo />
                              </td>
                            </tr>
                            <tr className="border-bottom d-flex">
                              <td style={{ width: "100%" }} colSpan="4">
                                <div className="d-flex justify-content-between">
                                  <AddButtonIconComponent
                                    buttonText="Add Another Slot"
                                    fontIcon="fa fa-plus"
                                    colorCss="blue"
                                  />
                                  <div className="enIconBtn">
                                    <Image
                                      src={require("../../../assets/images/UserManagement/Delete.svg")}
                                      alt="Delete"
                                      title="Delete"
                                      fluid
                                    />
                                  </div>
                                </div>
                              </td>
                            </tr>
                  </div>
                </div>
              </>
            </Media>

              <div className="d-flex align-items-center py-4 mobile-mb-4">
                <Button
                  variant="outline-secondary"
                  className="btn150 btn-lg mr-4 px-5"
                  // onClick={handleCloseEditRole}
                >
                  Cancel
                </Button>
                <Button variant="danger" className="btn150 btn-lg px-5">
                  Save
                </Button>
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
      <Modal
        show={showEditRole}
        size="lg"
        onHide={handleCloseEditRole}
        centered
      >
        <Modal.Header className="px-4 border-0" closeButton>
          {modelStep && (
            <div>
              <Modal.Title className="f20-700 pb-2">
                Copy time to another day
              </Modal.Title>
            </div>
          )}
        </Modal.Header>
        <Modal.Body
          className="px-4"
          style={{ minHeight: !modelStep && "500px" }}
        >
          {modelStep ? (
            <Form>
              <div className="f14-400 mb-4">
                Please select the date to copy the timing
              </div>

              <div className="d-flex align-items-center py-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                  onClick={handleCloseEditRole}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn150px btn-lg px-5"
                  onClick={changeStep}
                >
                  Choose
                </Button>
              </div>
            </Form>
          ) : (
            <div>
              <div className="d-flex">
                <div className="f12-500">Starts from</div>
                <div className="f12-500" style={{ marginLeft: "187px" }}>
                  Ends at
                </div>
              </div>
              <BasicDateRangePicker />
            </div>
          )}
        </Modal.Body>
        {modelStep ? (
          <></>
        ) : (
          <Modal.Footer>
            <div
              className="d-flex align-items-center py-4"
              style={{
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outline-secondary"
                className="btn-md mr-4 px-5"
                onClick={handleCloseEditRole}
              >
                CANCEL
              </Button>
              <Button variant="danger" className="btn-md px-5">
                OK
              </Button>
            </div>
          </Modal.Footer>
        )}
      </Modal>
    </React.Fragment>
  );
};
